import {useLocation, useParams} from 'react-router-dom';
import LogoDark from '../../../app/assets/img/logo-dark.webp';
import {InfoSection, InfoSectionProps} from '../../../app/components/InfoSection';
import {SuccessCode} from '../../../app/types';
import {successComponents} from '../successComponents';
const defaultInfoSectionProps: InfoSectionProps = {
  icon: 'check-circle',
  iconClassName: 'text-green-400',
  message: 'Operation is successful.',
  title: 'Success',
};
export const Success = () => {
  const location = useLocation();
  const params = useParams<{
    statusCode?: string;
  }>();
  const successCode = params.statusCode ?? location.state?.statusCode;
  return (
    <div className="flex flex-col h-full">
      <div
        className="flex items-center text-white h-[4rem] px-4 py-1 shrink-0 shadow-lg"
        style={{
          background: '#052244',
        }}
      >
        <img alt="Biotandem" className="h-full" src={LogoDark} />
      </div>
      <div className="flex-1 flex items-center justify-center overflow-auto">{renderSuccess()}</div>
    </div>
  );
  function renderSuccess() {
    const Component = successComponents[successCode as SuccessCode] ?? InfoSection;
    return <Component {...defaultInfoSectionProps} />;
  }
};
